<style lang="sass" src="./headers.sass" scoped></style>
<template lang="pug">
#page-header
  .container
    a.logo(href="https://www.upyun.com/" target="_blank")
      img(src="../assets/logo.svg")
    .navs
      router-link.nav(to="/dashboard", :class="{active: navNum === 1}") 总览
      router-link.nav(to="/statistic", :class="{active: navNum === 5}") 统计
      router-link.nav(to="/application", :class="{active: navNum === 3}") 应用管理
      a.nav(href="https://help.upyun.com/knowledge-base/sim-api/ ", target="_blank") 接口文档
    .side-navs
      a.console(href="https://console.upyun.com" target="_blank") 控制台首页
      a.profile(@mouseenter='mouseEnter', @mouseleave="mouseLeave") {{username || accountInfo.username}}
        i.arrow-down(class="el-icon-caret-bottom")
        .logout(:class="{show: showLogout, hide: !showLogout}", @click="logOut") 退出登录
</template>

<script>
import { getCookie, clearCookie } from '../utils/cookie'
import config from '../../config'

export default {
  data () {
    return {
      showLogout: false,
      accountInfo: {}
    }
  },
  computed: {},
  props: ['navNum', 'username'],
  mounted () {
    this.accountInfo = JSON.parse(localStorage.getItem('accountInfo'));
  },
  methods: {
    mouseEnter () {
      this.showLogout = true;
    },
    mouseLeave () {
      this.showLogout = false;
    },
    logOut () {
      this.$store.dispatch('logOut', {});
      clearCookie('cookieToken');
      clearCookie('accountInfo');
      localStorage.clear();
      if (process.env.NODE_ENV === 'development') {
        window.location.href = 'http://franky.upyun.com/accounts/signout/';
      } else {
        window.location.href = 'https://console.upyun.com/accounts/signout/';
      }
    }
  },
  beforeCreate () {
    const frankyToken = this.$route.query.token;
    const loginToken = getCookie('cookieToken');
    if (frankyToken) {
      clearCookie('cookieToken');
      this.$store.dispatch('getToken', {
        token: frankyToken,
        router: this.$router
      });
    } else if (loginToken) {
      return false;
    } else {
      if (process.env.NODE_ENV === 'development') {
        window.location.href = config.dev.login_url;
      } else {
        window.location.href = config.build.login_url;
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// headers.vue?26be7f61